module.exports = __webpack_public_path__ + "static/media/pluvicto_logo.5b9c1186.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pluvicto_logo.png
// module id = 1362
// module chunks = 0